import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Link,
  List,
  ListItem,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import BottomNav from '@/components/BottomNav';
import { defaultAttendance } from '@/consts';

export default function AttendanceGuideFaq() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [expanded, setExpanded] = useState(
    globalThis.location.hash.replace(/#|panel-|-content|-header/, ''),
  );
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Container component="main" maxWidth="xl">
      <Box component={Paper} sx={{ my: 4, padding: 2 }}>
        <Typography gutterBottom variant="h2" className="font-bebas">
          {t('attendance.title')}
        </Typography>
        {defaultAttendance.map((faq, index) => {
          const id = faq.question.split('.').slice(1, -1)[0];

          return (
            <Accordion
              key={id}
              expanded={expanded === id}
              onChange={handleChange(id)}
              elevation={2}
            >
              <AccordionSummary aria-controls={`panel-${id}-content`} id={`panel-${id}-header`}>
                <Typography variant="h5" fontWeight="bold">
                  {t(faq.question)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {faq.list.length > 0 && (
                  <List sx={{ paddingLeft: 2, listStyleType: 'disc' }}>
                    {faq.list.map((item, index_) =>
                      faq.links[index_] === null ? (
                        <ListItem key={item} sx={{ display: 'list-item' }}>
                          {t(item)}
                        </ListItem>
                      ) : (
                        <ListItem key={item} sx={{ display: 'list-item' }}>
                          {t(item)} <Link href={faq.links[index_]}>{faq.links[index_]}</Link>
                        </ListItem>
                      ),
                    )}
                  </List>
                )}
                {faq.answer.map((paragraph, index_) => (
                  <Typography
                    key={paragraph}
                    variant="body1"
                    sx={{ marginBottom: '16px' }}
                    color={
                      faq.list.length > 0 || (index === 4 && index_ === 1)
                        ? 'error'
                        : 'text.primary'
                    }
                  >
                    {t(paragraph)}
                  </Typography>
                ))}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      {isMobile && <BottomNav />}
    </Container>
  );
}
